import cuiTitle from './title.vue'
import cuiPhone from './phone.vue'

export default {
    install: function (Vue) {
        Vue.component('cui-title', cuiTitle)
        Vue.component('cui-phone', cuiPhone)
    }
}